import { formatCnpj } from 'utils/document';

export const applyCnpjMask = (cnpj) => {
  return formatCnpj(cnpj);
};
